module.exports = __webpack_public_path__ + "static/media/CHI Papers.3d43b5a8.csv";